import { render } from "./danish-flag.vue?vue&type=template&id=21d2e502"
import script from "./danish-flag.vue?vue&type=script&lang=js"
export * from "./danish-flag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__